/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { Permission, Unauthentication } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import {
  setEditFolderViewVisible,
  getUserFolderData,
  setSelectedUser
} from '../../flow/action';
import EditView from './departmentView';
import EmailTemplateDetail from './emailTemplateDetail';
import EmailEditFolder from './emailEditFolder';


class EmailTemplates extends React.Component {
  componentDidMount() {
    const {
      getUserFolderData, loginUser, setSelectedUser
    } = this.props;
    // get current user's folders as default
    getUserFolderData(loginUser.id);
    // set the radio button content as current user's name
    setSelectedUser(loginUser);
  }

  render() {
    const { isEditFolderViewVisible } = this.props;
    return (
      <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES} errorComponent={<Unauthentication />}>
        <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_SHOWTEAMSTRUCTURE}>
          <EditView />
        </Permission>
        {!isEditFolderViewVisible ? <EmailTemplateDetail /> : <EmailEditFolder />}
      </Permission>
    );
  }
}

const mapStateToProps = ({ setup, loginUser }) => {
  const { emailTemplates } = setup;
  return {
    isEditFolderViewVisible: emailTemplates.ui.isEditFolderViewVisible,
    loginUser
  };
};

const mapDispatchToProps = {
  setEditFolderViewVisible,
  setSelectedUser,
  getUserFolderData
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplates);




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/container/index.js